/**
 * @property COLOR
 * @type {Object}
 * @final
 */
export const COLOR = {
    BLUE_VERY_LIGHT: 'rgba(64, 127, 143, 1.0)',
    BLUE_VERY_LIGHT_02: 'rgba(64, 127, 143, 0.2)',
    BLUE_LIGHT: 'rgba(56, 111, 125, 1.0)',
    BLUE_MEDIUM_LIGHT: 'rgba(48, 96, 108, 1.0)',
    BLUE_MEDIUM: 'rgba(90, 180, 255, 1.0)',
    BLUE_MEDIUM_DARK: 'rgba(32, 64, 72, 1.0)',
    BLUE_MEDIUM_DARK_01: 'rgba(32, 64, 72, 0.1)',
    BLUE_DARK: 'rgba(24, 49, 55, 1.0)',
    BLUE_VERY_DARK: 'rgba(16, 33, 37, 1.0)',
    BLUE_01: 'rgba(30,120,255,1.0)',
    BLUE_02: 'rgba(70,70,170,1.0)',
    GREEN_LIGHT: 'rgba(193, 218, 205, 1.0)',
    GREEN_DARK: 'rgba(0,255,0,1.0)',
    GRAY_VERY_VERY_DARK: 'rgba(20, 20, 20, 1.0)',
    GRAY_BRIGHT: 'rgba(217, 217, 217, 1.0)',
    GRAY_DIM: 'rgba(140,140,140,1.0)',
    GRAY_DIMMER: 'rgba(54,54,54,1.0)',
    RED_BRIGHT: 'rgba(255, 0, 0, 1.0)',
    RED: 'rgba(224, 128, 128, 1.0)',
    RED_02: 'rgba(224, 128, 128, 0.2)',
    WHITE: 'rgba(255, 255, 255, 1.0)',
    WHITE_05: 'rgba(255, 255, 255, 0.5)',
    TRANSPARENT: 'rgba(0, 0, 0, 0)'
};
